import { z } from "zod"

export const CustomBikeTypeSchema = z.object({
  id: z.guid(),
  name: z.string(),
})

export const SaveCustomBikeTypeSchema = z.object({
  name: z.string().trim().min(1).max(64),
})

export type CustomBikeType = z.infer<typeof CustomBikeTypeSchema>
export type SaveCustomBikeType = z.infer<typeof SaveCustomBikeTypeSchema>
